export enum submissionActionTypes {
  SET_SUBMISSIONS = 'SET_SUBMISSIONS',
  SET_CURRENT_SUBMISSION = 'SET_CURRENT_SUBMISSION',
  SET_CURRENT_SUBMISSION_INITIAL_DATA = 'SET_CURRENT_SUBMISSION_INITIAL_DATA',
  SET_CURRENT_SUBMISSION_INITIAL_TITLE = 'SET_CURRENT_SUBMISSION_INITIAL_TITLE',
  SET_CURRENT_SUBMISSION_INITIAL_DESCRIPTION = 'SET_CURRENT_SUBMISSION_INITIAL_DESCRIPTION',
  CURRENT_SUBMISSION_LOADING = 'CURRENT_SUBMISSION_LOADING',
  CURRENT_SUBMISSION_FORM_CHANGED = 'CURRENT_SUBMISSION_FORM_CHANGED',
  CURRENT_SUBMISSION_TITLE_CHANGED = 'CURRENT_SUBMISSION_TITLE_CHANGED',
  CREATE_SUBMISSION_LOADING = 'CREATE_SUBMISSION_LOADING',
  DELETE_SUBMISSION_LOADING = 'DELETE_SUBMISSION_LOADING',
  DELETE_SUBMISSIONS_LOADING = 'DELETE_SUBMISSIONS_LOADING',
  UPDATE_SUBMISSION_LOADING = 'UPDATE_SUBMISSION_LOADING',
  DOWNLOAD_SUBMISSION_LOADING = 'DOWNLOAD_SUBMISSION_LOADING',
  DOWNLOAD_SUBMISSION_FAILURE = 'DOWNLOAD_SUBMISSION_FAILURE',
  CURRENT_SUBMISSION_FAILURE = 'CURRENT_SUBMISSION_FAILURE',
  CREATE_SUBMISSION_FAILURE = 'CREATE_SUBMISSION_FAILURE',
  DELETE_SUBMISSION_FAILURE = 'DELETE_SUBMISSION_FAILURE',
  UPDATE_SUBMISSION_FAILURE = 'UPDATE_SUBMISSION_FAILURE',
  REASSIGN_SUBMISSIONS_GROUP_LOADING = 'REASSIGN_SUBMISSIONS_GROUP_LOADING',
  REASSIGN_SUBMISSIONS_GROUP_FAILURE = 'REASSIGN_SUBMISSIONS_GROUP_FAILURE',
  CHANGE_SUBMISSIONS_TYPE_LOADING = 'CHANGE_SUBMISSIONS_TYPE_LOADING',
  CHANGE_SUBMISSIONS_TYPE_FAILURE = 'CHANGE_SUBMISSIONS_TYPE_FAILURE',
  SUBMISSIONS_FAILURE = 'SUBMISSION_FAILURE',
  NAVIGATE_TO_SUBMISSION = 'NAVIGATE_TO_SUBMISSION',
  SET_SUBMISSIONS_TOTAL = 'SET_SUBMISSIONS_TOTAL',
  SET_CHECKED_SUBMISSIONS = 'SET_CHECKED_SUBMISSIONS',
  SET_TEMPLATE_EDITOR_MODE = 'SET_TEMPLATE_EDITOR_MODE',
  DELETE_ORIGIN_SECTION = 'DELETE_ORIGIN_SECTION',
  CREATE_ORIGIN_SECTION = 'CREATE_ORIGIN_SECTION',
  UPDATE_ORIGIN_SECTION_BLOCK = 'UPDATE_ORIGIN_SECTION_BLOCK',
  CREATE_ORIGIN_SECTION_BLOCK = 'CREATE_ORIGIN_SECTION_BLOCK',
  DELETE_ORIGIN_SECTION_BLOCK = 'DELETE_ORIGIN_SECTION_BLOCK',
  UPDATE_ORIGIN_SECTION_BLOCKS_ORDER = 'UPDATE_ORIGIN_SECTION_BLOCKS_ORDER',
  UPDATE_ORIGIN_SECTIONS_ORDER = 'UPDATE_ORIGIN_SECTIONS_ORDER',
  UPDATE_CURRENT_SUBMISSION_ORIGIN_SECTION_NAME = 'UPDATE_CURRENT_SUBMISSION_ORIGIN_SECTION_NAME',
  UPDATE_CURRENT_SUBMISSION_TEMPLATE_EDITOR_FORM_CHANGED_FLAG = 'UPDATE_CURRENT_SUBMISSION_TEMPLATE_EDITOR_FORM_CHANGED_FLAG',
  SET_CURRENT_SUBMISSION_DEFAULT_ORIGIN_SECTIONS = 'SET_CURRENT_SUBMISSION_DEFAULT_ORIGIN_SECTIONS',
  RESET_UNSAVED_CHANGES_TEMPLATE_EDITOR_FORM = 'RESET_UNSAVED_CHANGES_TEMPLATE_EDITOR_FORM',
}
